export const selectFeatureFlags = (state) => state.featureFlags?.flags || []

export const selectFeatureFlag = (key) => (state) => selectFeatureFlags(state).includes(key)

export const selectFeatureFlagsSettled = (state) => state.featureFlags?.settled ?? true
